// Import function
function importAll(r) {
  return r.keys().map(r);
}

// Import all the images
const images = importAll(
  require.context('../../src/images', false, /\.(png|svg|jpg|jpeg|gif)$/i)
);

// Import all CSS
const css = importAll(require.context('../../src/css', false));

// Import all JS
const js = importAll(require.context('../../src/js', false));
